import axios from "axios";
import { getPlayerName } from "./ghostService";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// POST a finished run to the global leaderboard. Fire-and-forget.
// Returns the created entry (with id) so the EndScreen can show "You're #N".
export async function submitLeaderboard({ wave, score, levelId, zombies }) {
  try {
    const res = await axios.post(
      `${API}/leaderboard/submit`,
      {
        name: getPlayerName() || "Player",
        wave: wave || 1,
        score: score || 0,
        level_id: levelId || 1,
        zombies_collected: zombies || 0,
      },
      { timeout: 5000 }
    );
    return res.data;
  } catch {
    return null;
  }
}

export async function fetchLeaderboardTop(limit = 10) {
  try {
    const res = await axios.get(`${API}/leaderboard/top`, {
      params: { limit },
      timeout: 5000,
    });
    return Array.isArray(res.data) ? res.data : [];
  } catch {
    return [];
  }
}

// Bumps daily global counters (zombies + runs).
export async function incrementStats({ zombies = 0, runs = 0 }) {
  if (!zombies && !runs) return;
  try {
    await axios.post(
      `${API}/stats/increment`,
      { zombies, runs },
      { timeout: 5000 }
    );
  } catch {
    // ignore
  }
}

export async function fetchTodayStats() {
  try {
    const res = await axios.get(`${API}/stats/today`, { timeout: 5000 });
    return res.data || { zombies: 0, runs: 0 };
  } catch {
    return { zombies: 0, runs: 0 };
  }
}
